export const handlePostponedStructureCheck = (
    postponeTime: number | undefined,
    structureCheckFunc: (conversationUuid: string) => void,
    conversationUuid: string
) => {
    if (postponeTime) {
        setTimeout(() => structureCheckFunc(conversationUuid), postponeTime);
    }
};
